import Vue from 'vue'
import App from './App.vue'
import Router from './routes'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuetify from 'vuetify'
import VeeValidate from 'vee-validate'
import srcBaseURL from './baseurl'
import Print from 'vue-print-nb'
import FlagIcon from 'vue-flag-icon'
import VueQRCodeComponent from 'vue-qrcode-component'
import GSignInButton from 'vue-google-signin-button'
import VueHtmlToPaper from 'vue-html-to-paper'
import viewOrderDates from './components/viewOrderDates.vue'
import viewStepsDates from './components/viewStepsDates.vue'
import viewOrderUsers from './components/viewOrderUsers.vue'
import openWhatsAppAndViber from './components/openWhatsAppAndViber.vue'
import helpers from './mixins/helpers'
// import swal from 'sweetalert'
import BranchSelect from './BranchSelect.vue'
import DisplayBranch from './DisplayBranch.vue'
import orderImages from './components/orderImages.vue'
import Comment from './Comment.vue'
import VueOtp2 from 'vue-otp-2'

Vue.use(GSignInButton)
Vue.use(VueOtp2)

Vue.component('qr-code', VueQRCodeComponent)
Vue.component('view-order-dates', viewOrderDates)
Vue.component('view-steps-dates', viewStepsDates)
Vue.component('view-order-users', viewOrderUsers)
Vue.component('branch-select', BranchSelect)
Vue.component('display-branch', DisplayBranch)
Vue.component('open-whatsapp-and-viber', openWhatsAppAndViber)
Vue.component('order-images', orderImages)
Vue.component('comment', Comment)

const options = {
  // name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: ['assets/ltr/css/print_style.css']
}

Vue.mixin(helpers)

Vue.use(VueHtmlToPaper, options)

Vue.use(FlagIcon)

const HelloJs = require('hellojs/dist/hello.all.min.js')
const VueHello = require('vue-hellojs')
Vue.use(require('vue-moment'))

HelloJs.init({
  // OLD TOKEN
  // google: '874739111711-tdaea8acef469ov1ip14kakljr2te44q.apps.googleusercontent.com',

  google: '17629677592-96u7gdi6phhtb1t02lajhauf7dnir6ul.apps.googleusercontent.com', // ShipZone <Google Developer>
  facebook: 3408050599367161 // ShipZone <Facebook Developer>
}, {
  redirect_uri: 'https://ship-zone.com/'
  // redirect_uri: 'http://localhost/'
})
Vue.use(VueHello, HelloJs)

axios.defaults.baseURL = srcBaseURL.url
Vue.prototype.getFilePath = srcBaseURL.filePath

setInterval(function () {
  let secretDuration = localStorage.getItem('secret_duration')
  if (secretDuration != null) {
    if (secretDuration > 0) {
      secretDuration = secretDuration - 1
      localStorage.setItem('secret_duration', secretDuration)
    }
    if (secretDuration === 0) {
      localStorage.setItem('secret_key', false)
    }
  }
}, 60000)

// setInterval(function () {
//   let duration = localStorage.getItem('duration')
//   if (duration != null) {
//     //  COUNT DURATION ONLY FOR STAFFS
//     let userData = JSON.parse(localStorage.getItem('user_data'))
//     if (userData.is_staff) {
//       if (duration < 3) {
//         let token = localStorage.getItem('access_token')
//         axios.post('api/logout', '', { headers: { Authorization: 'Bearer ' + token } }).then(() => {
//           localStorage.clear()
//           window.location.href = '/'
//         })
//       } else {
//         duration = duration - 1
//         localStorage.setItem('duration', duration)
//       }
//     }
//   }
// }, 60000)

Vue.filter('usdFormat', (number) => {
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  })
  return formatter.format(number)
})

// setInterval(function () {
//     let token = localStorage.getItem('access_token');
//     let now = Date.now() / 1000;
//     let base64Url = token.split('.')[1];
//     let base64 = base64Url.replace('-', '+').replace('_', '/');
//     let jwtPayload = JSON.parse(window.atob(base64));
//
//     if ( ( (jwtPayload.exp + 59 ) - now) < 120 ) {
//         axios.post("api/refresh", '', { headers: { Authorization: 'Bearer ' + token }})
//             .then(response => {
//                 localStorage.setItem('access_token', response.data.access_token);
//             })
//             .catch(error => {
//                 // console.log(error.response);
//             });
//     }
// }, 60000);

axios.interceptors.request.use(
  function (config) {
    if (config.url !== 'api/order_notification') {
      localStorage.setItem('duration', 20)
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

// axios.interceptors.response.use(
//   function (response) {
//     return response
//   },
//   function (error) {
//     if (error.request.status === 401) {
//       if (
//         !error.request.responseURL.includes('api/order_notification') &&
//         !error.request.responseURL.includes('api/login')
//       ) {
//         localStorage.clear()
//         window.location.href = '/'
//       }
//     } else if (error.request.status === 403) {
//       swal('Unauthorized', "You don't have permission", 'error')
//     }
//     return Promise.reject(error)
//   }
// )

Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(Vuetify)
Vue.use(VeeValidate, {
  events: ''
})
Vue.use(Print)

new Vue({
  el: '#app',
  render: (h) => h(App),
  router: Router
})



// WEBPACK FOOTER //
// ./src/main.js